import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import LenisProvider from "@/components/LenisProvider";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

import Home from "@/pages/Home";
import Flotte from "@/pages/Flotte";
import Experiences from "@/pages/Experiences";
import Tarifs from "@/pages/Tarifs";
import Reservation from "@/pages/Reservation";
import Contact from "@/pages/Contact";
import CGV from "@/pages/CGV";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <LenisProvider>
          <ScrollToTop />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/flotte" element={<Flotte />} />
              <Route path="/experiences" element={<Experiences />} />
              <Route path="/tarifs" element={<Tarifs />} />
              <Route path="/reservation" element={<Reservation />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/cgv" element={<CGV />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#0A0A0A",
                color: "#fff",
                border: "1px solid rgba(196,162,77,0.4)",
                borderRadius: 0,
                fontFamily: "Manrope, sans-serif",
              },
            }}
          />
        </LenisProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
